import React from 'react';

import { SiteConfigManager } from '@atlas/core';

import { providers } from './constants';
import Smartico from './Smartico';
import Ziqni from './Ziqni';

const providersComponentsMap = {
  [providers.SMARTICO]: Smartico,
  [providers.ZIQNI]: Ziqni,
};

const Achievements = () => {
  const provider = SiteConfigManager.getConfig('config.config.general.gamificationTool');

  const Component = providersComponentsMap[provider];

  return Component ? <Component /> : null;
};

export default Achievements;
